// import Stats from "three/addons/libs/stats.module.js";
import '@shaders/glsl-noise/periodic/2d.glsl';
import {GLTFLoader} from "three/addons/loaders/GLTFLoader.js";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer'
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass'
import {OutlineEffect} from 'three/addons/effects/OutlineEffect.js';
import {PencilLinesPass} from "@js/PencilLinesPass";
import {OrbitControls} from "three/addons/controls/OrbitControls.js";
import {DRACOLoader} from "three/addons/loaders/DRACOLoader.js";
import {
  fabIcon,
  tierLieuIcon,
  homeIcon,
  mrIcon,
  elecIcon,
  comIcon,
  collabIcon,
  comTitle,
  fabIconTitle, tierLieuTitle, mrTitle, elecTitle, collabTitle, contactIcon
} from "./iconAnim.js";
import {
  AmbientLight, CatmullRomCurve3,
  CineonToneMapping,
  Clock, Euler,
  Group, Mesh, MeshStandardMaterial, MeshToonMaterial,
  PerspectiveCamera,
  Scene,
  Vector3,
  WebGLRenderer,
  SRGBColorSpace
} from "three";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";

gsap.registerPlugin(ScrollTrigger,ScrollToPlugin, MorphSVGPlugin);

let canvas = document.getElementById("root");
let groupAccueil = new Group();
let previousTime = 0;
let effect
let controls;

let scene = new Scene()

let cameraGroup = new Group()
scene.add(cameraGroup)

//ancienne fov 20
let camera = new PerspectiveCamera(
  75,
  window.innerWidth / window.innerHeight,
  0.1,
  1000
)
cameraGroup.add(camera)

let renderer = new WebGLRenderer({
  canvas: canvas,
  antialias: true,
  alpha: true,
})

renderer.setPixelRatio( window.devicePixelRatio);
renderer.setSize( window.innerWidth, window.innerHeight );
renderer.setClearColor(0xdad4d4, 1)
// renderer.useLegacyLights = true
// renderer.outputColorSpace = SRGBColorSpace
// renderer.toneMapping = CineonToneMapping
// renderer.toneMappingExposure = 1.75

//post processing
effect = new OutlineEffect( renderer );

const composer = new EffectComposer(renderer)
const renderPass = new RenderPass(scene, camera)
const pencilLinePass = new PencilLinesPass({
  width: renderer.domElement.clientWidth,
  height: renderer.domElement.clientHeight,
  scene,
  camera
})

composer.addPass(renderPass)
composer.addPass(pencilLinePass)

let clock = new Clock()
//
// let stats = Stats()
// document.body.appendChild(stats.dom)

//Light
const ambientLight = new AmbientLight(0xdad4d4, 1)
scene.add(ambientLight)

// fonction pour charger le charly de la scène
const objects = () => {
  // const toonMateriel = new MeshToonMaterial({
  //   color: 0xdad4d4,
  // })

  //Draco loader
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('draco/');

  //Object of the scene
  const loaderCharlylab = new GLTFLoader();
  loaderCharlylab.setDRACOLoader(dracoLoader);
  loaderCharlylab.load('./3d/charlylabV2web.glb', (gltf) => {

    const geometry = gltf.scene.children[0].geometry;

    // const charlyLab = new Mesh(geometry, toonMateriel);
    const charlyLab = new Mesh(geometry, new MeshStandardMaterial({color: 0xdad4d4}));
    charlyLab.castShadow = false;
    groupAccueil.add(charlyLab);
  });

  scene.add(groupAccueil);

  // attendre que la fenêtre soit chargée pour lancer l'animation
  window.addEventListener('DOMContentLoaded', () => {
    animate();
  })
}

let hover = false;
let hoverElem;
let angle = 0;
let lastElem;

const selectHover = (event) => {
  hover = true;
  const target = event.target;
  const nodeName = target.nodeName;

  if (nodeName === 'path' || nodeName === 'svg') {
    hoverElem = target.nodeName === 'path' ? target.parentElement.id : target.id;
  } else if (nodeName === 'H2' || nodeName === 'LI' || nodeName === 'A') {
    hoverElem = target.children[0].children[0]?.id || target.children[0].id;
  }
}

let iconLi = document.querySelectorAll('.iconLi');
let iconTitle = document.querySelectorAll('.iconTitle');
iconLi.forEach((elem) => {
  elem.addEventListener('mouseover', selectHover);
  elem.addEventListener('mouseout', () => {
    hover = false;
  });
});

iconTitle.forEach((elem) => {
  elem.addEventListener('mouseover', selectHover);
  elem.addEventListener('mouseout', () => {
    hover = false;
  });
});

const resetIcon = () => {
  homeIcon.rotate.y = homeIcon.rotate.y * 0.9;
  tierLieuIcon.rotate.y = tierLieuIcon.rotate.y * 0.9;
  tierLieuTitle.rotate.y = tierLieuTitle.rotate.y * 0.9;
  fabIcon.rotate.y = fabIcon.rotate.y * 0.9;
  fabIconTitle.rotate.y = fabIconTitle.rotate.y * 0.9;
  mrIcon.rotate.y = mrIcon.rotate.y * 0.9;
  mrTitle.rotate.y = mrTitle.rotate.y * 0.9;
  elecIcon.rotate.y = elecIcon.rotate.y * 0.9;
  elecTitle.rotate.y = elecTitle.rotate.y * 0.9;
  comIcon.rotate.y = comIcon.rotate.y * 0.9;
  comTitle.rotate.y = comTitle.rotate.y * 0.9;
  collabIcon.rotate.y = collabIcon.rotate.y * 0.9;
  collabTitle.rotate.y = collabTitle.rotate.y * 0.9;
  contactIcon.rotate.y = contactIcon.rotate.y * 0.9;
  angle = 0;
}

const resetSingleIcon = (icon) => {
  switch (icon) {
    case 'homeIcon':
      homeIcon.rotate.y = 0;
      break;
    case 'tierLieuIcon':
    case 'tierLieuTitle':
      tierLieuIcon.rotate.y = 0;
      tierLieuTitle.rotate.y = 0;
      break;
    case 'fabIcon':
    case 'fabIconTitle':
      fabIcon.rotate.y = 0;
      fabIconTitle.rotate.y = 0;
      break;
    case 'mrIcon':
    case 'mrIconTitle':
      mrIcon.rotate.y = 0;
      mrTitle.rotate.y = 0;
      break;
    case 'elecIcon':
    case 'elecIconTitle':
      elecIcon.rotate.y = 0;
      elecTitle.rotate.y = 0;
      break;
    case 'comIcon':
    case 'comIconTitle':
      comIcon.rotate.y = 0;
      comTitle.rotate.y = 0;
      break;
    case 'collabIcon':
    case 'collabIconTitle':
      collabIcon.rotate.y = 0;
      collabTitle.rotate.y = 0;
      break;
    case 'contactIcon':
      contactIcon.rotate.y = 0;
      break;
  }
  angle = 0;
}

const zgraphUpdate = () => {
  homeIcon.updateRenderGraph();
  tierLieuIcon.updateRenderGraph();
  tierLieuTitle.updateRenderGraph();
  fabIcon.updateRenderGraph();
  fabIconTitle.updateRenderGraph();
  mrIcon.updateRenderGraph();
  mrTitle.updateRenderGraph();
  elecIcon.updateRenderGraph();
  elecTitle.updateRenderGraph();
  comIcon.updateRenderGraph();
  comTitle.updateRenderGraph();
  collabIcon.updateRenderGraph();
  collabTitle.updateRenderGraph();
  contactIcon.updateRenderGraph();
}

//fonction pour animer la scène
function animate() {
  previousTime = clock.getElapsedTime();

  zgraphUpdate();

  if (hoverElem !== undefined) {
    if (lastElem !== hoverElem) {
      resetSingleIcon(lastElem);
      lastElem = hoverElem;
    }
    if (hover) {
      angle += 0.006;
      switch (hoverElem) {
        case 'homeIcon':
          homeIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'tierLieuIcon':
        case 'tierLieuTitle':
          tierLieuIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          tierLieuTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'fabIcon':
        case 'fabIconTitle':
          fabIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          fabIconTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'mrIcon':
        case 'mrIconTitle':
          mrIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          mrTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'elecIcon':
        case 'elecIconTitle':
          elecIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          elecTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'comIcon':
        case 'comIconTitle':
          comIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          comTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'collabIcon':
        case 'collabIconTitle':
          collabIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          collabTitle.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
        case 'contactIcon':
          contactIcon.rotate.y = Math.abs(Math.sin(angle) * 0.9);
          break;
      }
    } else {
      resetIcon();
    }
  }
  requestAnimationFrame(animate);
  // stats.update();
  if (controls){
    controls.update();
  }
  render()
}

//fonction pour rendre la scène
let render = () => {
  composer.render()
}

//resize
const resize = () => {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
  if (window.innerWidth <= 850) {
    //change moi la position de la caméra
    camera.position.set(-20, 45, 66)
    camera.lookAt(0, 0, 0)
    //change le fov
    camera.fov = 15;
    camera.updateProjectionMatrix();
    controls = new OrbitControls(camera, renderer.domElement)
    controls.maxPolarAngle = Math.PI / 2;
  //   bloque le dezoom à 3
    controls.maxDistance=150;
  }
  else {
    if (controls){
      controls.dispose();
    }
    //reset la position de la caméra
    camera.fov = 70;
    camera.updateProjectionMatrix();
    camera.lookAt(0, 0, 0)
    camera.rotation.set(-1.5, 0, 0)
    camera.position.x=-6;
    camera.position.y=17;
  }
}

objects();

camera.lookAt(0, 0, 0)
//Courbe de trajectoire de la caméra
// const curveAll = new THREE.CatmullRomCurve3([
//   new THREE.Vector3(-6, 17, 1),
//   new THREE.Vector3(-5, 5, 15),
//   new THREE.Vector3(-4, 1, -2.4),
//   new THREE.Vector3(-1, 1, -2.4),
//   new THREE.Vector3(-1, 1, -5.5),
//   new THREE.Vector3(2.5, 1, -5.5),
//   new THREE.Vector3(2.5, 2, -4.7),
//   new THREE.Vector3(2.5, 1, -3),
//   new THREE.Vector3(0, 1, 0),
//   new THREE.Vector3(1, 1, 3),
//   new THREE.Vector3(3, 1, 3),
//   new THREE.Vector3(3, 1, 2),
//   new THREE.Vector3(0, 1.5, 1.5),
//   new THREE.Vector3(-2, 1, 3),
//   new THREE.Vector3(-2.8, 1, 5.5),
//   new THREE.Vector3(0.8, 1, 5.5),
//   new THREE.Vector3(2.7, 1, 5.5),
//   new THREE.Vector3(2.7, 1, 8),
//   new THREE.Vector3(-5, 5, 15),
//   new THREE.Vector3(-5, 13, 1),
// ]);

let curve1 = new CatmullRomCurve3([
  new Vector3(-6, 17, 1),
  new Vector3(-5, 3, 10),
  new Vector3(-5, 2, 7),
  new Vector3(-5, 1, 5),
  new Vector3(-5, 1, -2.4),
  new Vector3(-3, 1, -2.4),
]);

let rotate1 = new CatmullRomCurve3([
  new Vector3(-1.5, 0, 0),
  new Vector3(0, 0, 0),
  new Vector3(0, -1.5, 0),
  new Vector3(0, -1.5, 0),
]);

let curve2 = new CatmullRomCurve3([
  new Vector3(-3, 1, -2.4),
  new Vector3(-1, 1, -2.4),
  new Vector3(-1, 1, -5.5),
  new Vector3(0.5, 1, -5.7),
]);

let rotate2 = new CatmullRomCurve3([
  new Vector3(0, -1.5, 0),
  new Vector3(0, -0.8, 0),
  new Vector3(0, 0, 0),
  new Vector3(0, -0.5, 0),
]);

let curve3 = new CatmullRomCurve3([
  new Vector3(0.5, 1, -5.7),
  new Vector3(2.5, 2, -4.7),
  new Vector3(2.5, 1, -3),
  new Vector3(0.8, 1, 0),
]);

let rotate3 = new CatmullRomCurve3([
  new Vector3(0, -0.5, 0),
  new Vector3(0, 1.5, 0),
  new Vector3(0, 2.5, 0),
  new Vector3(0, 2, 0),
]);

let curve4 = new CatmullRomCurve3([
  new Vector3(0.8, 1, 0),
  new Vector3(1, 1, 1),
  new Vector3(1.5, 1, 3),
])

let rotate4 = new CatmullRomCurve3([
  new Vector3(0, 2, 0),
  new Vector3(0, 2.5, 0),
  new Vector3(0, 4.8, 0),
]);

let curve5 = new CatmullRomCurve3([
  new Vector3(1.5, 1, 3),
  new Vector3(3, 1, 3.5),
  new Vector3(3, 1, 2),
  new Vector3(0, 1.5, 1.5),
  new Vector3(-2, 1, 2.8),
]);

let rotate5 = new CatmullRomCurve3([
  new Vector3(0, 4.8, 0),
  new Vector3(0, 6.6, 0),
  new Vector3(0, 7.2, 0),
  new Vector3(0, 8, 0),
  new Vector3(0, 8, 0),
]);

let curve6 = new CatmullRomCurve3([
  new Vector3(-2, 1, 2.8),
  new Vector3(-2.8, 1, 5.5),
  new Vector3(1.5, 1.5, 5.5),
]);

let rotate6 = new CatmullRomCurve3([
  new Vector3(0, 8, 0),
  new Vector3(0, 9.5, 0),
  new Vector3(0.5, 9.4, 0),
]);

let curve7 = new CatmullRomCurve3([
  new Vector3(1.5, 1.5, 5.5),
  new Vector3(2.7, 1, 5.5),
  new Vector3(2.7, 1, 8),
]);

let rotate7 = new CatmullRomCurve3([
  new Vector3(0.5, 9.4, 0),
  new Vector3(0, 9.4, 0),
]);

camera.rotation.set(-1.5, 0, 0)

camera.position.copy(new Vector3(-6, 17, 1));

//initialise la scène en fonction de la taille de l'écran
resize();
window.addEventListener('resize', resize)

let mm = gsap.matchMedia()

ScrollTrigger.defaults({
  // Définition de l'ease par défaut
  ease: "power2.inOut"
});

mm.add("(min-width: 850px)", () => {
  const triggers = [
    { trigger: "#accueil", duration: 5, curve: curve1, rotate: rotate1 },
    { trigger: "#tier-lieu", duration: 3, curve: curve2, rotate: rotate2 },
    { trigger: "#communication", duration: 3, curve: curve3, rotate: rotate3 },
    { trigger: "#mr", duration: 3, curve: curve4, rotate: rotate4 },
    { trigger: "#printer", duration: 3, curve: curve5, rotate: rotate5 },
    { trigger: "#electronique", duration: 10, curve: curve6, rotate: rotate6 },
    { trigger: "#collabs", duration: 3, curve: curve7, rotate: rotate7 }
  ];

  triggers.forEach(({ trigger, duration, curve, rotate }) => {
    ScrollTrigger.create({
      trigger,
      start: "top top",
      end: "bottom top",
      scrub: 1,
      duration,
      onUpdate: self => {
        camera.position.copy(curve.getPoint(self.progress));
        camera.rotation.copy(new Euler().setFromVector3(rotate.getPoint(self.progress)));
      }
    });
  });
});


// morph svg of the projects

// Démarre la timeline uniquement lors de l'entrée dans la section #collabs
let tl;

if (window.innerWidth <= 850) {
  // Sur mobile, on lance la timeline directement
  tl = gsap.timeline({ repeat: -1, repeatDelay: 1, yoyo: true, defaults: { duration: 2, ease: "power2.inOut" } });
  tl.to("#ar-glasses", { duration: 2, morphSVG: "#exercise-bike" }, "+=1")
    .to("#ar-glasses", { duration: 2, morphSVG: "#flower"}, "+=1")
    .to("#ar-glasses", { duration: 2, morphSVG: "#statue"}, "+=1")
    .to("#ar-glasses", { duration: 2, morphSVG: "#billard"}, "+=1")
    .to("#ar-glasses", { duration: 2, morphSVG: "#gloves"}, "+=1")
    .to("#ar-glasses", { duration: 2, morphSVG: "#ar-glasses"}, "+=1");
} else {
  // Desktop : déclenchement via ScrollTrigger
  ScrollTrigger.create({
    trigger: "#collabs",
    start: "top center",
    end: "bottom top",
    onEnter: () => {
      if (!tl) {
        tl = gsap.timeline({ repeat: -1, repeatDelay: 1, yoyo: true, defaults: { duration: 2, ease: "power2.inOut" } });
        tl.to("#ar-glasses", { duration: 2, morphSVG: "#exercise-bike" }, "+=1")
          .to("#ar-glasses", { duration: 2, morphSVG: "#flower"}, "+=1")
          .to("#ar-glasses", { duration: 2, morphSVG: "#statue"}, "+=1")
          .to("#ar-glasses", { duration: 2, morphSVG: "#billard"}, "+=1")
          .to("#ar-glasses", { duration: 2, morphSVG: "#gloves"}, "+=1")
          .to("#ar-glasses", { duration: 2, morphSVG: "#ar-glasses"}, "+=1");
      } else {
        tl.play();
      }
    },
    onLeave: () => {
      if (tl) tl.pause();
    },
    onEnterBack: () => {
      if (tl) tl.play();
    },
    onLeaveBack: () => {
      if (tl) tl.pause();
    }
  });
}